import styled from 'styled-components';

import ActionButton from 'components/action-button';

export const StyledAddCreditCardButton = styled(ActionButton)`
  text-transform: capitalize;
`;
